import { GiftItem } from "../../types";

export const emptyGiftItem = (order: number): GiftItem => ({
  image: "",
  integration_id: "",
  last_sync_change: 0,
  last_sync_time: 0,
  en_description: "",
  description: "",
  created_at: 0,
  ar_name: "",
  ar_description: "",
  updated_at: 0,
  pos_image_path: "",
  price: 0,
  name: "",
  en_name: "",
  id: "",
  updated_first_time_pos: 0,
  order,
  category_id: "",
  is_placeholder: 1,
  show_price: 1,
});
